<template>
  <v-app>
    <navbar @drawer="drawer = !drawer" />
    <sidebar v-model="drawer" />

    <v-main class="blue-grey lighten-5">
      <v-container fluid class="container-view">
        <router-view />
        <snackbar />
      </v-container>
    </v-main>

    <v-footer app color="blue-grey" class="white--text">
      <v-spacer />
      <span>CLO Virtual Fashion&copy; 2020</span>
    </v-footer>
  </v-app>
</template>

<script>
import navbar from './components/navbar'
import sidebar from './components/sidebar'
import snackbar from '@/components/snackbar'

export default {
  name: 'DefaultLayout',
  components: { sidebar, navbar, snackbar },
  props: {
    source: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    drawer: true
  })
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  width: 100%;
}
</style>
